import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as reducers from '../store/reducers';
import * as usersActions from '../store/users/actions';

import Loading from 'Components/Loading';

class LogoutPage extends React.Component {
  componentDidMount() {
    this.props.postUserLogout();
  }

  render() {
    return <Loading />;
  }
}

export default connect(false, usersActions)(LogoutPage);
